'use client'

import styled from 'styled-components'

export const MainContent = styled.div`
  display: block;
`

